import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";

const AntrepoDashboard3 = () => {
    return (
        <KTCard>
            <KTCardBody>
                <Box mb='2rem'>
                    <h2 className='m-0 p-0'>Antrepo Dashboard 3</h2>
                </Box>
            </KTCardBody>
        </KTCard>
    )
}

export default AntrepoDashboard3;